
import { ReactNode } from "react";

import HeaderUser from "../organisms/HeaderUser";
import Footer from "../organisms/Footer";

type LayoutProps = {
  children: ReactNode;
};

export default function MainLayoutUser({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <HeaderUser />
      <main className="flex-grow">{children}</main>
      <Footer/>
    </div>
  );
}
